<template>
  <el-row class="member-card d-flex align-items-center">
    <el-col
      :xs="4"
      :sm="4"
      :md="2"
    >
      <user-avatar
        shape="circle"
        :author-exist="!!member"
        :size="45"
        :src="member.avatar"
        :alt="`${member ? member.full_name : ''} Profile picture`" 
        :show-label="true"
      ></user-avatar>
    </el-col>
    <el-col
      :xs="16"
      :sm="16"
      :md="14"
    >
      <p class="mb-0 font-weight-bold">
        {{ member.full_name }}
      </p>
      <p class="mb-0">
        {{ member.role }} <span v-if="member.role && member.organisation_name">|</span> {{ member.organisation_name }}
      </p>
    </el-col>
    <el-col
      :xs="8"
      :sm="8"
      :md="8"
    >
      <span
        v-if="member.is_nominated"
        class="nominated font-weight-bold pull-right"
      ><i class="el-icon-check font-weight-bold mr-2"></i>Nominated</span>
      <a
        v-else
        role="button"
        class="font-weight-bold mark-as-owner pull-right"
        @click="markAsOwner()"
      >Mark as owner</a>
    </el-col>
  </el-row>
</template>
<script>
import UserAvatar from '@/components/core/user-avatar'
export default {
  name:'OrganisationMemberCard',
  components:{
    UserAvatar
  },
  props: {
    member: {
      type: Object,
      required: true,
    },
  },
  emits: ['mark-as-owner'],
  methods:{
    markAsOwner(){
      this.$emit('mark-as-owner', this.member)
    }
  }
}
</script>
<style lang="scss">
.member-card{
  width: 100%;
  border-bottom: 1px solid #D9D9D9;
  padding: 15px 0;
  p{
    font-size: 1.1rem;
    font-weight: 500;
    color: #000000;
    text-align: unset !important;
  }
  &:last-of-type {
    border-bottom: none;
    padding: 0;
  }
  .mark-as-owner{
    text-decoration: underline;
    cursor: pointer;
    &:hover{
      text-decoration: none;
    }
  }
  .nominated{
    color: #65AB2D;
  }
}
</style>
